import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import type { Volume } from '../data/volumes';
type Props = {
  volume: Volume;
};
export function VolumeItem({
  volume
}: Props) {
  const [open, setOpen] = useState(false);
  const panelId = `volume-${volume.n}-panel`;
  return <li className="rounded-2xl border border-line bg-ink-2" data-id="element-333" data-mp="1lvvdzuvgzwgx">
      <div className="flex gap-4 p-5" data-id="element-334" data-mp="1lt8z1a692eoo">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-gold/50 bg-gold/10 font-display text-lg font-bold text-gold" data-id="element-335" data-mp="1qvhovxntt0mk">
          {String(volume.n).padStart(2, '0')}
        </span>
        <div className="min-w-0 flex-1" data-id="element-336" data-mp="20l1avc6u5aln">
          <h3 className="font-display text-lg font-bold uppercase leading-tight text-fog sm:text-xl" data-id="element-337" data-mp="24m3ahu4nzoo5">
            <span aria-hidden="true" data-id="element-338" data-mp="29lfyii79v1sb">{volume.emoji} </span>
            {volume.title}
          </h3>
          <p className="mt-0.5 text-sm font-semibold text-teal" data-id="element-339" data-mp="2ek10am269tiv">{volume.subtitle}</p>
          <p className="mt-2 text-sm leading-relaxed text-fog/70" data-id="element-340" data-mp="2ehy41kaff45p">{volume.desc}</p>
          <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={panelId} className="mt-3 inline-flex items-center gap-1.5 text-sm font-bold text-gold transition-colors duration-150 ease-out hover:text-gold-soft focus:outline-none focus-visible:underline" data-id="element-341" data-mp="2bwbo50m8mz8w">
            {open ? 'Hide contents' : 'See what’s inside this volume'}
            <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-342" data-mp="2qnkj7p8wtctf" />
          </button>
        </div>
      </div>

      <div id={panelId} className="grid transition-[grid-template-rows] duration-200 ease-out" style={{
      gridTemplateRows: open ? '1fr' : '0fr'
    }} data-id="element-343" data-mp="2gxiwb0sam0g3">
        <div className="overflow-hidden" data-id="element-344" data-mp="3edonzzxu3im0">
          <div className="border-t border-line px-5 pb-5 pt-4 sm:pl-[84px]" data-id="element-345" data-mp="3eepya271012o">
            <p className="text-sm leading-relaxed text-fog/70" data-id="element-346" data-mp="39kvl7hlxekck">{volume.detail}</p>
            <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-347" data-mp="3siys5nso4gj8">
              {volume.includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-fog/80" data-id="element-348" data-mp="1bm5wucxhcwg">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-349" data-mp="3jpbwdxognda1" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-4 text-sm text-fog/80" data-id="element-350" data-mp="39qwac94aiu7e">
              <span className="font-bold text-gold" data-id="element-351" data-mp="3er0ohshq7cug">The objective:</span> {volume.objective}
            </p>
          </div>
        </div>
      </div>
    </li>;
}